import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const FPConfirmationTitleDiv = styled(BaseStyles.Div)`
    text-align: center;
    width: 100%;
`

export const FPConfirmationPhraseDiv = styled(BaseStyles.Div)`
    display: flex; 
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const FPConfirmationTitle = styled.h2`  
    margin: 0;
    padding: 0;
    padding-bottom: 2.5rem;
    font-size: 2.2rem;
    font-weight: 550;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center
`

export const FPConfirmationPhrase = styled.p`
    margin: 0;
    padding: 0;
    padding-top: 3rem;
    padding-bottom: 3rem;
    width: 100%;
    font-size: 1.6rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    overflow-wrap: break-word;
`

export const FPConfirmationExitPhrase = styled.p`
    margin: 0;
    width: 100%;
    padding: 0;
    padding-top: 3rem;
    font-size: 1.6rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    overflow-wrap: break-word;
`